import React from 'react';
import PropTypes from 'prop-types';
import getHTMLElement from '../lib/setHtmlHelper';
import formatDate from '../lib/dateHelper';
import getContent from 'pp-react-l10n';

export default class ArticleHero extends React.Component {
  constructor(props) {
    super(props);
    this.handleFirstTab = this.handleFirstTab.bind(this);
    this.renderFontClassName = this.renderFontClassName.bind(this);
  }
  componentDidMount() {
    window.addEventListener("keydown", this.handleFirstTab);
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleFirstTab);
  }
  /* eslint-disable */
  handleFirstTab(e) {
    if (e.keyCode === 9) {
      // the "I am a keyboard user" key
      document.body.classList.add("user-is-tabbing");
    }
  }
  /* eslint-enable */

  renderFontClassName() {
    const { content } = this.props.articleInfo;
    if (content.heading && content.heading.length <= 45) {
      return "articleHero_headline10 h1";
    } else if (
      content.heading &&
      content.heading.length > 45 &&
      content.heading.length < 100
    ) {
      return "articleHero_headline45 h1";
    } else if (
      content.heading &&
      content.heading.length >= 100 &&
      content.heading.length < 150
    ) {
      return "articleHero_headline100 h1";
    } else if (content.heading && content.heading.length >= 150) {
      return "articleHero_headline150 h1";
    } else {
      return "";
    }
  }

  render() {
    const { metadata, content, breadCrumbs } = this.props.articleInfo;
    const palBlue = "circle at 0 0, #0070ba, #1546a0";
    const locale = this.props.locale.split("_")[0];
    const country = this.props.country.toLowerCase();
    const getPopContent = getContent('staticContent');

    const updatedDate = formatDate(metadata.updated_time, country, locale);

    const backgroundImageStyle =
      content && content.lg_bg
        ? {
          backgroundImage: `url(${content.lg_bg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundColor: "#0070ba",
        }
        : {
          backgroundColor: "#003087",
          backgroundImage: `radial-gradient(${palBlue})`,
        };
    const fontChange =
      country === "vn" && this.props.locale === "vi_VN" ? "vnFont" : country === 'jp' && this.props.locale === 'ja_JP' ? 'jpFont' : "";
    const pageType = breadCrumbs && breadCrumbs.length !== 0 && breadCrumbs[0].id && breadCrumbs[0].id === "enterprise-solutions" ? "enterprisePage" : "";

    let contactSalesBtnText = "";
    if (pageType && pageType === "enterprisePage") {
      contactSalesBtnText = getPopContent('brc.contactSalesBtnText');
    }

    const contactSalesBtnDisplayCountryLists = ['us', 'au', 'ca'];
    return (
      <div id="article-hero">
        <section className="articleHero" style={backgroundImageStyle}>
          <div className="container">
            <div className="row">
              <div className="articleHero__container col-xs-12 col-lg-11 text-xs-left">
                <h1
                  className={`${this.renderFontClassName()} articleHero__headline h1 ${fontChange}`}
                  id="contentHeading"
                >
                  {getHTMLElement(content.heading, { useHTML: true })}
                </h1>
                <p className="articleHero__meta">
                  {updatedDate} {"|"} {content.author}
                </p>
              </div>
            </div>
          </div>
          {pageType && pageType === "enterprisePage" && contactSalesBtnDisplayCountryLists.includes(country) ?
            <div className="contact-sales-btn-wrapper">
              <a
                target="_blank"
                role="button"
                className="contact-sales-btn pypl-btn"
                href={`https://www.paypal.com/${country}/enterprise/contact-sales?utm_source=brc_enterprise`}
              >
                {contactSalesBtnText}
              </a>
            </div>
            : null
          }
        </section>
      </div>
    );
  }
}
ArticleHero.propTypes = {
  articleInfo: PropTypes.shape({
    metadata: PropTypes.shape({
      updated_time: PropTypes.any,
      author: PropTypes.string,
    }),
    content: PropTypes.shape({
      lg_bg: PropTypes.string,
    }),
  }),
};
